import { Link } from "react-router-dom";

export default function Logo({ lang, light = false }) {
  return (
    <Link
      to={`/${lang}`}
      data-testid="logo-link"
      className="flex items-baseline gap-0 font-display text-2xl font-extrabold tracking-tighter"
      aria-label="BoingCars home"
    >
      <span className={light ? "text-white" : "text-petrol"}>boing</span>
      <span className={light ? "text-ember" : "text-foreground"}>cars</span>
      <span className="ml-0.5 inline-block h-2 w-2 rounded-full bg-ember" aria-hidden="true" />
    </Link>
  );
}
